<template lang="pug">
.v-filter.filter(v-if="data" :id="data?.id")
	template(v-if="staticView && !isTablet")
		v-form(v-if="data.fields" :form="{...data, buttons: null}" @response="handlerResponse" :action="action" :hide-message="true")
	template(v-else="")
		.filter__btn(@click="open = !open")
			button.btn.btn--stroke
				v-svg-icon.btn__icon(icon="graphic-filter")
				| {{data.title}}
				span.filter__btn-count(v-if="filterCount") ({{filterCount}})
		teleport(to="body")
			v-panel(v-if="isTablet" :open-state="open" :close-text="data.closeText" body-class="filter__mob-panel-body" @close="open = false" :show-mode="true")
				template(#content)
					.filter__panel-form-title(v-if="data.title") {{data.title}}
					v-form.filter__panel-form(v-if="data.fields" :form="{...data}" @response="handlerResponse" :action="action" :hide-message="true")
			template(v-else="")
				transition(name="overlay")
					.filter__overlay(v-if="open" @click="open = false")
				.filter__panel(:class="{'open': open}")
					.filter__panel-head
						.filter__panel-title(v-if="data.title") {{data.title}}
						button.filter__close(type="button" @click="open = false")
							v-svg-icon.filter__close-icon(icon="filter-close")
					.filter__panel-body.scrollbar(ref="panel")
						v-form.filter__panel-form(v-if="data.fields" :form="{...data, title: null}" @response="handlerResponse" :action="action" :hide-message="true")
</template>

<script>

import scrollLock from 'scroll-lock';
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		isMobMixin
	],

	emits: [
			'openStateChange',
			'filterUpdated'
	],

	props: {
		filter: {
			type: Object,
			default: null
		},

		action: {
			type: String,
			default: null
		},

		openState: {
			type: Boolean,
			default: false
		},

		staticView: {
			type: Boolean,
			default: null
		}
	},

	data() {
		return {
			data: null,
			open: false,
			filterCount: null
		}
	},

	mounted() {
		if (this.filter) {
			this.data = this.filter;
			this.filterCount = this.filter.filterCount;
		}
	},

	watch: {
		open(state) {
			if (state) {
				scrollLock.disablePageScroll(this.$refs.panel);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.panel);
				}, 300);
			}
			this.$emit('openStateChange', state);
		},

		filter(state) {
			this.data = state;
		},

		openState(state) {
			this.open = state;
		}
	},

	methods: {
		handlerResponse(response, options) {
			this.data = response;
			this.filterCount = response.filterCount;
			this.$emit('filterUpdated', response);
			if (options.closePanel) {
				this.open = false;
			}
		}
	}
}

</script>